import { DonutChartComponent } from '../charts/donut-chart-component'

export class AFCompareSovByMentionTypeDonut extends DonutChartComponent {
 static config = {
  selector: 'afCompareSovByMentionTypeDonut',
  controller: AFCompareSovByMentionTypeDonut,
  bindings: DonutChartComponent.config.bindings,
  template: DonutChartComponent.config.template,
 }

 setProperties() {
  this.seriesData = this.namingUtils.returnData(
   this.sortCompareArray(this.vizData.data, this.visualizationMetaData)
  )

  this.seriesColors = this.colorUtils.compareMetaByNameLoop(
   this.seriesData,
   this.visualizationMetaData,
   'key'
  )
 }
 onPointClick = () => {}
}
